import { elements } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import resize from '@mailobj-browser/front/js/events/types/resize.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { removed, rendered } from '@mailobj-browser/front/js/tree/tree.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import rect from '#utilities/js/ea/rect.js'

const forms = new WeakMap()
const resizers = new WeakMap()

const resized = async (defaultView, form) => {
  queueMicrotask(async () => {
    const { ownerDocument } = form
    const { body } = ownerDocument

    await rendered(form, body)

    const { document, innerHeight } = defaultView
    const { documentElement } = document
    const { clientHeight } = documentElement
    const viewportHeight = Math.max(clientHeight ?? 0, innerHeight ?? 0)
    const actions = one(`.${elements.rte_actions}`, form)
    const actionsStickyBottom = getComputedStyle(actions).getPropertyValue('--ea_rte_actions_sticky_bottom')
    const { top } = rect(form)
    const { style } = form

    if (actionsStickyBottom === 'false') {
      style.setProperty('--ea_mail_send_form_height', `${viewportHeight - top}px`)
    } else {
      style.setProperty('--ea_mail_send_form_height', '100%')
    }
  })
}

const onResize = object(listener, {
  type: resize,
  passive,
  task: (defaultView) => {
    const { document, requestAnimationFrame } = defaultView
    const nestedForms = forms.get(document)

    for (const form of nestedForms) {
      if (!document.contains(form)) {
        nestedForms.delete(form)

        break
      }

      resizers.set(form, async () => {
        resizers.delete(form)

        if (forms.get(document).has(form) && document.contains(form)) {
          await resized(defaultView, form)
        }
      })

      requestAnimationFrame(() => {
        resizers.get(form)?.()
      })
    }
  }
})

// @todo FB fichier probablement à supprimer lorsque web2 et default seront fusionnés et que les
// structures HTML (div_IN etc) seront passés en fragment
export default form => {
  const { ownerDocument } = form
  const { defaultView } = ownerDocument

  if (!forms.has(ownerDocument)) {
    forms.set(ownerDocument, new Set())
  }
  // Permet de récupérer 'form' via l'event resize
  forms.get(ownerDocument).add(form)
  onResize.task(defaultView)
  onResize.listen(defaultView)

  queueMicrotask(async () => {
    const nestedForms = forms.get(ownerDocument)

    await removed(form)
    nestedForms.delete(form)
    resizers.delete(form)
  })
}